// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mbwix","badges":"styles_badges__1n0ZP"};